import { Directive, ElementRef, EventEmitter, Input, OnChanges, Output, Renderer2 } from '@angular/core';
import { RemoteImageService } from '@flipto/shared/src/lib/services/images/remote-image.service';
import { first } from 'rxjs/operators';

@Directive({
    selector: '[ftBackgroundImage]',
    standalone: true
})
export class BackgroundImageDirective implements OnChanges {

    constructor(
        public elemRef: ElementRef,
        public renderer: Renderer2,
        public remoteImage: RemoteImageService) {
    }

    @Input() fallbackImage: string | null = null;
    @Input() fallbackClass: string | null = null;
    @Input() checkExistence = true;
    @Input('ftBackgroundImage') backgroundImage: string | null = null;
    @Input() size2xImage!: string;
    @Input() shimmerClass!: string;

    @Output() imageNotFound = new EventEmitter<boolean>();

    ngOnChanges(): void {
        this.onSetBackgroundUrl();
    }

    onSetBackgroundUrl(): void {
        if (!!this.shimmerClass) {
            this.addShimmerClass();
        }

        if (this.checkExistence) {
            this.remoteImage.checkExistence(this.backgroundImage ?? '')
                .pipe(first())
                .subscribe(exists => {
                    if (exists) {
                        this.setBackgroundUrl(this.backgroundImage!);
                        this.imageNotFound.next(false);
                    } else if (!!this.fallbackImage) {
                        this.setBackgroundUrl(this.fallbackImage!);
                        this.imageNotFound.next(true);
                    } else if (!!this.fallbackClass) {
                        this.fallbackClass.split(' ').forEach(cssClass => this.addClass(cssClass));
                        this.imageNotFound.next(true);
                    } else {
                        this.imageNotFound.next(true);
                    }

                    if (!!this.shimmerClass) {
                        this.removeShimmerClass();
                    }
                });
        } else {
            this.setBackgroundUrl(this.backgroundImage!);

            if (!!this.shimmerClass) {
                this.removeShimmerClass();
            }
        }
    }


    private setBackgroundUrl(url: string) {
        this.renderer.setStyle(this.elemRef.nativeElement, 'background-image', this.size2xImage ? `-webkit-image-set(url('${url}') 1x, url('${this.size2xImage}') 2x), url('${url}')` : `url('${url}')`);
    }

    private addClass(cssClass: string) {
        this.renderer.addClass(this.elemRef.nativeElement, cssClass);
    }

    private removeShimmerClass() {
        this.renderer.removeClass(this.elemRef.nativeElement, this.shimmerClass);
    }

    private addShimmerClass() {
        this.renderer.addClass(this.elemRef.nativeElement, this.shimmerClass);
    }
}
